import * as localStyles from "./textureDisplayManager.module.scss";
export class TextureDisplayManager {
    getHeaderClass() {
        return "";
    }
    shouldDisplayPortLabels() {
        return true;
    }
    getHeaderText(nodeData) {
        return nodeData.data.name;
    }
    getBackgroundColor(nodeData) {
        return "#323232";
    }
    updatePreviewContent(nodeData, contentArea) {
        const block = nodeData.data;
        if (!this._previewImage) {
            contentArea.classList.add(localStyles["texture-block"]);
            this._previewImage = contentArea.ownerDocument.createElement("img");
            contentArea.appendChild(this._previewImage);
            this._previewImage.classList.add(localStyles.empty);
            // Create an off-screen canvas for converting texture data to data URL
            this._previewCanvas = contentArea.ownerDocument.createElement("canvas");
        }
        const url = block.textureDataUrl || block.url;
        if (url) {
            this._previewImage.src = url;
            this._previewImage.classList.remove(localStyles.empty);
        }
        else if (block.sourceTexture) {
            // For procedural textures (like noise), extract content and convert to data URL
            void this._extractAndDisplayTextureAsync(block);
        }
        else {
            this._previewImage.classList.add(localStyles.empty);
        }
    }
    async _extractAndDisplayTextureAsync(block) {
        try {
            const textureData = await block.extractTextureContentAsync();
            if (textureData) {
                const dataUrl = this._textureDataToDataUrl(textureData.data, textureData.width, textureData.height);
                if (dataUrl) {
                    this._previewImage.src = dataUrl;
                    this._previewImage.classList.remove(localStyles.empty);
                }
                else {
                    this._previewImage.classList.add(localStyles.empty);
                }
            }
        }
        catch {
            // If extraction fails, just show empty state
            this._previewImage.classList.add(localStyles.empty);
        }
    }
    _textureDataToDataUrl(data, width, height) {
        this._previewCanvas.width = width;
        this._previewCanvas.height = height;
        const ctx = this._previewCanvas.getContext("2d");
        if (ctx) {
            const imageData = new ImageData(data, width, height);
            ctx.putImageData(imageData, 0, 0);
            return this._previewCanvas.toDataURL("image/png");
        }
        return "";
    }
}
//# sourceMappingURL=textureDisplayManager.js.map